<ng-container *ngFor="let item of data">
    <div *ngIf="!processLoading" (click)="action(item._id)" class="webhook-card">
        <div class="name-section">
          <span class="name">{{item.name}}</span>
          <span class="type">Expires: {{formatDate(item.duration)}}</span>
        </div>
        <div class="middle">
          <span *ngIf="item.ipAddresses.length > 0" class="title">IP Address:<span class="data"> {{item.ipAddresses}}</span></span>
        </div>
        <div class="end">
          <div (click)="remove_(item._id)"  class="icon-delete"></div>
        </div>
      </div>
</ng-container>
<div *ngIf="processLoading">
    <ngx-skeleton-loader></ngx-skeleton-loader>
    <ngx-skeleton-loader></ngx-skeleton-loader>
    <ngx-skeleton-loader></ngx-skeleton-loader>
</div>
<div *ngIf="data.length == 0" class="empty-state">
  <span class="empty-header">No Data Found</span>
  <span class="empty-body">You don't have any requests from your webhooks</span>
</div>


